module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbed-box",
    class: [_vm.rootClasses]
  }, [(!_vm.isMobile) ? _c('cmp-tabs', {
    attrs: {
      "facet": this.content.facet,
      "items": _vm.plugins,
      "passive-mode": true,
      "idx": _vm.activeTabIdx
    },
    on: {
      "request-change": function($event) {
        _vm.updateState($event, true)
      }
    },
    scopedSlots: _vm._u([{
      key: "head",
      fn: function(props) {
        return [_c('span', {
          staticClass: "tabbed-box--head",
          domProps: {
            "textContent": _vm._s(props.item.content.name)
          }
        })]
      }
    }, {
      key: "body",
      fn: function(props) {
        return [_c('div', {
          staticClass: "tabbed-box--body"
        }, [_c(props.item.type, {
          tag: "component",
          attrs: {
            "plugin": props.item
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.plugins), function(plugin, pluginIdx) {
    return (_vm.isMobile) ? _c('cmp-accordion', {
      key: pluginIdx,
      attrs: {
        "is-active": _vm.tabStates[pluginIdx],
        "passive-mode": true
      },
      on: {
        "request-change": function($event) {
          _vm.updateState(pluginIdx, $event)
        },
        "changed": function($event) {
          _vm.onAccordionStateChanged($event)
        }
      },
      scopedSlots: _vm._u([{
        key: "head",
        fn: function(props) {
          return [_c('span', {
            ref: "accordionHead",
            refInFor: true,
            staticClass: "tabbed-box--head",
            class: [props.isActive ? 'tabbed-box--head__is-open' : '']
          }, [_c('cmp-scroll-anchor', {
            staticClass: "tabbed-box--anchor",
            attrs: {
              "id": _vm.ariaUid('anchor', pluginIdx)
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "tabbed-box--head-text",
            domProps: {
              "textContent": _vm._s(plugin.content.name)
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "tabbed-box--head-arrow"
          }, [(_vm.isMobile) ? _c('cmp-icon', {
            staticClass: "tabbed-box--head-icon",
            attrs: {
              "symbol": "chevron_down",
              "size": "x-small"
            }
          }) : _vm._e()], 1)], 1)]
        }
      }, {
        key: "body",
        fn: function(props) {
          return [_c('div', {
            staticClass: "tabbed-box--body"
          }, [_c(plugin.type, {
            tag: "component",
            attrs: {
              "plugin": plugin
            }
          })], 1)]
        }
      }])
    }) : _vm._e()
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5bd6245c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd6245c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/tabbed-box/index.vue
// module id = 549
// module chunks = 7